function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M19.2195 16.8573L16.78 31.1728H20.6815L23.123 16.8573H19.2195Z",
  fill: "white"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.5087 16.8734L9.68753 26.6361L9.28012 25.162C8.52651 23.3859 6.38711 20.8351 3.87543 19.2275L7.36951 31.1658L11.4978 31.1588L17.642 16.8704L13.5087 16.8734Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.79897 17.8979C7.57219 17.0259 6.91491 16.766 6.09909 16.7349H0.0501735L0 17.0198C4.70728 18.1618 7.82205 20.9133 9.11452 24.2218L7.79897 17.8979Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M31.0303 19.6018C32.3067 19.5817 33.2319 19.8607 33.9504 20.1497L34.3026 20.3153L34.8305 17.2125C34.0578 16.9225 32.8466 16.6115 31.3354 16.6115C27.4801 16.6115 24.7627 18.5532 24.7416 21.3358C24.7165 23.3919 26.6773 24.5399 28.1584 25.2252C29.6787 25.9277 30.1884 26.3742 30.1814 27.0014C30.1694 27.9597 28.9692 28.3992 27.8483 28.3992C26.2859 28.3992 25.4561 28.1835 24.1746 27.6496L23.6719 27.4208L23.123 30.6249C24.0361 31.0253 25.721 31.3695 27.47 31.3875C31.5712 31.3875 34.2364 29.4689 34.2645 26.4956C34.2816 24.869 33.241 23.6277 30.9862 22.6092C29.6215 21.9449 28.7866 21.5034 28.7946 20.833C28.7946 20.238 29.503 19.6018 31.0303 19.6018Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M44.8431 16.8734H41.8287C40.8924 16.8734 40.196 17.1283 39.7846 18.0615L33.9916 31.1809H38.0887C38.0887 31.1809 38.7571 29.4168 38.9086 29.0305C39.3571 29.0305 43.3379 29.0365 43.9049 29.0365C44.0213 29.5362 44.3805 31.1809 44.3805 31.1809H48L44.8431 16.8734ZM40.0315 26.1003C40.3526 25.2785 41.5858 22.0995 41.5858 22.0995C41.5648 22.1386 41.9039 21.2716 42.1056 20.7328L42.3685 21.967C42.3685 21.967 43.1161 25.3848 43.2727 26.1003H40.0315Z",
  fill: "white"
});

var SvgPaymentVisa = function SvgPaymentVisa(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPaymentVisa, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payment_visa.f930acae.svg";
export { ForwardRef as ReactComponent };